import { render, staticRenderFns } from "./IssueSideBar.vue?vue&type=template&id=39b3bf1a&scoped=true&"
import script from "./IssueSideBar.vue?vue&type=script&lang=js&"
export * from "./IssueSideBar.vue?vue&type=script&lang=js&"
import style0 from "./IssueSideBar.vue?vue&type=style&index=0&id=39b3bf1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b3bf1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
